"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}
const products = [{
  id: 1,
  name: "Premium Refrigerators",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/premium_stainless_steel_refrigerator.png",
  discount: "Up to 60% OFF"
}, {
  id: 2,
  name: "Smart Dishwasher",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/modern_smart_dishwasher.png",
  discount: "Up to 60% OFF"
}, {
  id: 3,
  name: "Front Load Washer and Dryers",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/front_load_washing_machine.png",
  discount: "Up to 50% OFF"
}];
export default function UnbeatableDealsOnTopBrands() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const gtag_report_conversion = (url?: string) => {
    const callback = function () {
      if (typeof url != 'undefined') {
        window.location.href = url;
      }
    };
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-974995529/J1BHCKOvnJUBEMmA9dAD',
        'event_callback': callback
      });
    }
    return false;
  };
  return <section ref={ref} className="relative bg-dark-background py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground-dark mb-4">
            Unbeatable Deals on Top Brands
          </h2>
          <p className="text-lg text-foreground-dark/80 max-w-2xl mx-auto">Discover our extensive selection of New, Scratch and Dent appliances and lightly used offerings at steep discounts with fast delivery</p>
          <p className="text-lg font-semibold text-secondary mt-3 max-w-2xl mx-auto">
            No Credit Check Financing Available
          </p>
          <p className="text-base text-foreground-dark/70 mt-4 max-w-3xl mx-auto">Looking for quality New or used appliances in the Raleigh-Durham area? Smart Buy Appliances offers premium new and scratch and dent appliances at unbeatable prices. Serving Raleigh, Durham, and surrounding NC communities with top-brand appliances you can trust.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {products.map((product, i) => <div key={product.id} data-index={i} className="group relative" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? "translateY(0)" : "translateY(2rem)",
          transition: `opacity var(--duration-medium) var(--ease-smooth) ${i * 150}ms, transform var(--duration-medium) var(--ease-smooth) ${i * 150}ms`
        }}>
              <Card className="relative bg-background overflow-hidden border-2 border-border hover:border-primary transition-all duration-[var(--duration-medium)] hover:shadow-strong">
                <div className="relative aspect-[4/3] bg-muted overflow-hidden">
                  <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-105 group-hover:translate-y-[-4px]" />
                  
                  <div className="absolute top-4 right-4">
                    <Badge variant="destructive" className="bg-secondary text-foreground-dark font-bold text-base px-4 py-2 shadow-strong hover:bg-secondary-hover hover:scale-110 hover:brightness-110 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]" style={{
                  animation: isVisible ? `pulse-once var(--duration-medium) var(--ease-spring) ${i * 150 + 300}ms` : "none"
                }}>
                      {product.discount}
                    </Badge>
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-display font-semibold text-foreground mb-2">
                    {product.name}
                  </h3>
                  <p className="text-sm text-foreground/70">
                    Limited time offer - Fast delivery available
                  </p>
                </div>
              </Card>
            </div>)}
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse-once {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }
      `}</style>
    </section>;
}